// extracted by mini-css-extract-plugin
export default {"home":"ChangePassword_home__arQpA"};